<p-toast position="bottom-left">
</p-toast>
<div class="login">
  @if(imagePath){
  <div class="col-left" [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }">
  </div>
  }
  @if(imagePath === undefined){
  <div class="col-left">
    <app-swiper-login></app-swiper-login>
  </div>
  }
  <div class="col-right">
    <form name="authForm" novalidate style="height: 100%">
      <div class="login-form">
        <div class="form">
          <div class="form__inner">
            <div class="form__header">
              <div class="login-logo">
                <img src="assets/images/logo.svg" alt="" />
              </div>

              <h3>Forgot Password?</h3>
              <p class="small--text">Enter your user ID below, and we'll send you the password reset link</p>
            </div>

            <fieldset class="form__group" [ngClass]="{ 'error--field': isError }">
              <label class="form__label">ENTER USER ID</label>
              <div class="single-input-field-wrapper">
                <div class="form__field">
                  <input class="form__input" type="email" name="email" (keyup)="onChange($event)" [(ngModel)]="email"
                    required />
                  @if(isError){
                  <div class="validation validation--error bottom-n15">
                    {{ 'User ID is required.' }}
                  </div>
                  }
                </div>
              </div>
            </fieldset>
            <fieldset class="form__group login-pf-settings">
              <div id="kc-form-options" class="kc-form-options">
                <div class="forgotpwd ">
                  <span><a id="forgotPasswordLink" tabindex="5" (click)="goBack()">
                      Back to Login.
                    </a></span>
                </div>
              </div>
            </fieldset>
            <fieldset class="form__group login--actions">
              <button [disabled]="isSubmit" class="login-btn" (click)="forgotPassword(email)">SEND</button>
            </fieldset>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>